import { Avatar, Box, Button, HStack, Input, VisuallyHidden, useToast } from '@chakra-ui/react';
import React from 'react';
import { MdUpload } from 'react-icons/md';
import { translate } from '../../../i18n';
import { useUpdateCoachAvatar } from '../hooks/useUpdateCoachAvatar';

type Props = { coachId: string; fullName: string; avatar?: string; }
const AvatarUpload = ({ fullName, avatar, coachId }: Props) => {
    const toast = useToast();
    const { mutateAsync: uploadFile, isLoading: isUploading } = useUpdateCoachAvatar(coachId);

    const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
            try {
                await uploadFile(selectedFile);
            } catch (error) {
                toast({
                    title: translate('error'),
                    description: (error as Error)?.message || translate('error'),
                    status: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
            }
        }
    };

    return (
        <Box textAlign="center">
            <Avatar src={avatar} name={fullName} size="2xl" my={4} />
            <HStack justify="center" spacing={4}>
                <VisuallyHidden>
                    <Input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        id="file-input"
                    />
                </VisuallyHidden>
                <Button isLoading={isUploading} as="label" htmlFor="file-input" colorScheme="brand" leftIcon={<MdUpload />}>
                    {translate('upload_image')}
                </Button>
            </HStack>
        </Box>
    );
};

export default AvatarUpload;
